import React, { useState } from 'react';
import { PhoneCall, Sparkles, Menu, X } from 'lucide-react';
import { AnimatedThemeToggler } from './magicui/AnimatedThemeToggler';
import { ShimmerButton } from './magicui/ShimmerButton';
import { GradeLynkLogo } from './GradeLynkLogo';

export function Navbar({ onOpenMatcher, onOpenBooking }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-slate-200/80 bg-white/80 backdrop-blur-md dark:border-slate-800/80 dark:bg-slate-950/80 transition-colors duration-300">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8 h-16">
        
        {/* Brand Logo & Dynamic Theme SVG Monogram */}
        <a href="#" className="flex items-center gap-2">
          <GradeLynkLogo />
        </a>

        {/* Desktop Navigation Links */}
        <nav className="hidden md:flex items-center gap-8 text-xs font-semibold text-slate-700 dark:text-slate-300">
          <a href="#founders" className="hover:text-amber-600 dark:hover:text-amber-400 transition">Founders</a>
          <a href="#system" className="hover:text-amber-600 dark:hover:text-amber-400 transition">Active System</a>
          <a href="#offerings" className="hover:text-amber-600 dark:hover:text-amber-400 transition">Specialized Mentors</a>
          <button
            onClick={onOpenMatcher}
            className="inline-flex items-center gap-1.5 text-amber-600 dark:text-amber-400 font-bold hover:text-amber-500 transition cursor-pointer"
          >
            <Sparkles className="h-3.5 w-3.5" /> Career Matcher
          </button>
        </nav>

        {/* Desktop CTA & Theme Toggler */}
        <div className="hidden md:flex items-center gap-4">
          <AnimatedThemeToggler />

          <a
            href="tel:+14374382820"
            className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-700 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white transition cursor-pointer"
          >
            <PhoneCall className="h-3.5 w-3.5 text-amber-500" /> +1 (437) 438-2820
          </a>

          {/* Shimmer Button for Primary Navbar CTA */}
          <ShimmerButton
            onClick={onOpenBooking}
            shimmerColor="#ffffff"
            background="rgba(234, 179, 8, 1)"
            className="text-xs px-4 py-2"
          >
            Book Strategy Call
          </ShimmerButton>
        </div>

        {/* Mobile Controls */}
        <div className="flex md:hidden items-center gap-2">
          <AnimatedThemeToggler />

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle Navigation Menu"
            className="p-2 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-100 dark:border-slate-800 dark:text-slate-300 dark:hover:bg-slate-900 transition"
          >
            {mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

      </div>

      {/* Mobile Drawer Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-slate-200 bg-white/95 dark:border-slate-800 dark:bg-slate-950/95 px-4 pt-4 pb-6 space-y-4 shadow-xl">
          <nav className="flex flex-col space-y-3 text-sm font-medium text-slate-700 dark:text-slate-300">
            <a href="#founders" onClick={() => setMobileMenuOpen(false)} className="hover:text-amber-500">Founders</a>
            <a href="#system" onClick={() => setMobileMenuOpen(false)} className="hover:text-amber-500">Active System</a>
            <a href="#offerings" onClick={() => setMobileMenuOpen(false)} className="hover:text-amber-500">Specialized Mentors</a>
            <button
              onClick={() => { setMobileMenuOpen(false); onOpenMatcher(); }}
              className="flex items-center gap-2 text-amber-600 dark:text-amber-400 font-bold text-left"
            >
              <Sparkles className="h-4 w-4" /> Career Matcher Quiz
            </button>
          </nav>

          <div className="pt-2 border-t border-slate-100 dark:border-slate-800 flex flex-col gap-3">
            <a
              href="tel:+14374382820"
              className="inline-flex items-center justify-center gap-2 py-3 rounded-xl border border-slate-200 bg-slate-50 font-bold text-xs text-slate-900 dark:border-slate-800 dark:bg-slate-900 dark:text-white"
            >
              <PhoneCall className="h-4 w-4 text-amber-500" /> Call Kian: +1 (437) 438-2820
            </a>

            <ShimmerButton
              onClick={() => { setMobileMenuOpen(false); onOpenBooking(); }}
              shimmerColor="#ffffff"
              background="rgba(234, 179, 8, 1)"
              className="w-full text-xs py-3"
            >
              Book Strategy Session
            </ShimmerButton>
          </div>
        </div>
      )}
    </header>
  );
}
